import React, { useState } from 'react';
import { LOGO_SRC, LOGO_BASE64, SITE_NAME } from '../constants/logo';

const Logo = ({ className = 'h-9 max-w-[200px] object-contain', style = {} }) => {
  const [src, setSrc] = useState(LOGO_SRC);

  return (
    <img
      src={src}
      alt={SITE_NAME}
      className={className}
      style={style}
      onError={() => setSrc(LOGO_BASE64)}
      data-testid="taskpiece-logo"
    />
  );
};

export default Logo;
